// extracted by mini-css-extract-plugin
module.exports = {"list":"list-nMVlimgHEG","title":"title-buNiY3VV60","hr":"hr-i0L3jq7P5O","desc":"desc-G0EVLG_9i9"};